// extracted by mini-css-extract-plugin
export default {"wrap":"header_wrap__NPWyI","input":"header_input__b4Ff8","title":"header_title__j5wSX","text":"header_text__0xFdP","name":"header_name__Jzl6G"};